"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageGapsSection = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Small advisory banner that flags missing canonical links for the
 * element (e.g. a risk with no mitigation). Hidden when there are
 * no gaps to report so a complete catalogue stays clutter-free.
 */
exports.CoverageGapsSection = function (_a) {
    var gaps = _a.gaps;
    if (!gaps || gaps.length === 0)
        return null;
    return (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "coverage-gaps" },
        react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, "Coverage gaps"),
        react_1.default.createElement("ul", { className: "ws-entity-popup-list", style: {
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
            } }, gaps.map(function (gap) { return (react_1.default.createElement("li", { key: gap, style: {
                display: 'flex',
                alignItems: 'flex-start',
                gap: 8,
                padding: '6px 8px',
                background: '#fffbeb',
                border: '1px solid #fde68a',
                borderRadius: 4,
                fontSize: 12,
                color: '#92400e',
            } },
            react_1.default.createElement("i", { className: "ms-Icon ms-Icon--Warning", "aria-hidden": "true", style: { marginTop: 2 } }),
            react_1.default.createElement("span", null, gap))); }))));
};
